import { SessionPollData } from '@texas/api/endpoints/sessionApi';

export class ConfigureCompositionGroupGarp {
  constructor(
    public compositionGroupId: number,
    public variantId: number,
    public branchId: number,
    public productApprovalId?: number,
  ) {}
}

export class ServerStatePoll {
  constructor(public data: SessionPollData) {}
}

export class OpenGlobalSearch {}
